import React from "react";

export default function PasswordStrength({ allValid }) {
  return (
    <div
      className={`sp-form-password-strength ${allValid ? "strong" : "weak"}`}
    >
      <p>{allValid ? "STRONG" : "WEAK"}</p>
    </div>
  );
}
